import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {deleteAllRecentSearches} from '/redux/action/search.action';
import {hasRecentSearches} from '/redux/selector/search.selector';
import {withHOC} from '/util/hoc.util';

import {RecentSearches} from './RecentSearches';

export const RecentSearchesConnected = withHOC(
  connect(
    createStructuredSelector({
      hasRecentSearches,
    }),
    dispatch => ({
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      deleteAllRecentSearches: () => dispatch(deleteAllRecentSearches()),
    }),
  ),
)(RecentSearches);
